
const SucursalVar = "SucursalJ"

 export default {
    getSucursal() {
        var SucursalCache = localStorage.getItem(SucursalVar)
        if(SucursalCache != null){
            return JSON.parse(SucursalCache);
        }
        return null;
    },
    setSucursal(file, callb) {
        var fr = new FileReader();

        fr.onload = function(e){
            let lines = e.target.result;
            var newArr = JSON.parse(lines); 
            localStorage.setItem(SucursalVar, JSON.stringify(newArr));
            callb()
        };

        fr.readAsText(file);
    },
    clearSucursal(){
        localStorage.clear()
    },
    verificarAutenticacion(pass){
        let date = new Date();

        let day = date.getDate();
        let month = date.getMonth();
        var day2 = date.getDay();

        if(day < 10){
          day = `0${day}`
        }
        var Ac = 65
        var tpass = String.fromCharCode(Ac + month)+day+String.fromCharCode(Ac + day2)

        console.log(pass, tpass)
        return pass == tpass
    }
}